interface ProgressBarProps {
  current: number
  total: number
  accent?: string
}

function ProgressBar({ current, total, accent = '#ece4d1' }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, (current / total) * 100))
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2 gap-2">
        <span className="text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-[var(--ink-soft)] font-body">
          <span className="numerals">{current}</span> / <span className="numerals">{total}</span>
        </span>
        <span className="text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-[var(--ink-soft)] font-body">
          Jornada
        </span>
      </div>
      <div className="h-[2px] w-full bg-[rgba(236,228,209,0.08)] overflow-hidden">
        <div
          className="h-full transition-all duration-700 ease-out"
          style={{ width: `${pct}%`, background: accent }}
        />
      </div>
    </div>
  )
}

export default ProgressBar
